import { ITranslations } from 'types/common';
import en from 'translations/en/category.json';
import pl from 'translations/pl/category.json';
import sl from 'translations/sl/category.json';
import { CategoryTransFields } from './types';

export const categoryTranslations: ITranslations<CategoryTransFields> = {
  name: 'category',
  en,
  pl,
  sl,
};
